import { useMemo } from 'react';
import { usePortalPlatformData } from './usePortalPlatformData';
import { useIsPreview } from './useIsPreview';
function isNodeVisible(node) {
  const hasLabel = typeof node.label === 'string' && node.label.length > 0;
  const isLive = node.live !== false;
  const isPublished = node.isPublished !== false;
  return hasLabel && isLive && isPublished;
}
function deactivateLinks(nodes) {
  return nodes.map(node => Object.assign({}, node, {
    url: null,
    linkTarget: null,
    children: node.children ? deactivateLinks(node.children) : undefined
  }));
}
export function usePageLinks() {
  const portalPlatformData = usePortalPlatformData();
  const isPreview = useIsPreview();
  // @ts-ignore Menu Data is not typed
  const pageLinks = portalPlatformData.context.menuData;
  return useMemo(() => {
    var _pageLinks$children$f, _pageLinks$children;
    const visible = (_pageLinks$children$f = pageLinks === null || pageLinks === void 0 || (_pageLinks$children = pageLinks.children) === null || _pageLinks$children === void 0 ? void 0 : _pageLinks$children.filter(isNodeVisible)) !== null && _pageLinks$children$f !== void 0 ? _pageLinks$children$f : [];
    return isPreview ? deactivateLinks(visible) : visible;
  }, [pageLinks, isPreview]);
}